(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ihc-cell-lab"] && !Shopify.designMode) return;
  try {
    
(function(){
  var USE={li:[[1,'Torches, single-cell gadgets'],[2,'7.4 V robots and RC cars'],[3,'11.1 V RC models and robots'],[4,'14.8 V FPV drones and power tools'],[6,'22.2 V long-range FPV and big drones'],[7,'24 V scooters and motors'],[10,'36 V e-bikes'],[13,'48 V e-bikes and scooters'],[14,'52 V e-bikes']],
           lfp:[[1,'3.2 V solar lights'],[2,'6.4 V small systems'],[4,'12 V lead-acid replacement, solar and UPS'],[8,'24 V solar and inverters'],[16,'48 V home storage']]};
  function fx(n,d){return (Math.round(n*Math.pow(10,d))/Math.pow(10,d)).toLocaleString('en-IN',{maximumFractionDigits:d})}
  function init(root){
    if(root.dataset.ready)return;root.dataset.ready='1';
    var cells=[].slice.call(root.querySelectorAll('.ihx-cl__cell')),cur=cells.filter(function(c){return c.getAttribute('aria-checked')==='true'})[0]||cells[0];
    var S=root.querySelector('[data-in=s]'),P=root.querySelector('[data-in=p]');
    function o(k){return root.querySelector('[data-o='+k+']')}
    function set(k,v){var e=o(k);if(e)e.textContent=v}
    function draw(){
      if(!cur)return;var d=cur.dataset,s=+S.value,p=+P.value,n=s*p,v=s*d.v,ah=p*d.mah/1000,a=p*d.a,g=n*d.g;
      root.style.setProperty('--k',d.colour);
      set('name',d.name);set('name2',d.name);set('sp',s+'S'+p+'P');set('s',s+'S');set('p',p+'P');
      set('v',fx(v,1));set('vmax',fx(s*d.vmax,1));set('ah',fx(ah,2));set('wh',fx(v*ah,0));set('a',fx(a,0));set('w',fx(v*a,0));set('n',n);
      set('kg',g>=1000?fx(g/1000,2)+' kg':fx(g,0)+' g');
      var list=USE[d.chem]||USE.li,u='';list.forEach(function(x){if(s>=x[0])u=x[1]});set('use','Typical use: '+u);
      var stock=d.stock==='0'?' Currently out of stock: ask us for the next batch.':'';set('note',(d.note||'')+stock);
      var shop=o('shop');if(shop&&d.url)shop.href=d.url;
      var wa=o('wa');if(wa){var msg='Hi IHC, please quote a '+s+'S'+p+'P battery pack with '+d.name+' cells ('+fx(v,1)+' V, '+fx(ah,2)+' Ah).';wa.href='https://wa.me/'+root.dataset.wa+'?text='+encodeURIComponent(msg)}
      var mat=o('mat');mat.style.setProperty('--s',s);mat.style.setProperty('--p',p);
      if(mat.children.length!==n){var h='';for(var i=0;i<n;i++)h+='<i></i>';mat.innerHTML=h}
      root.classList.remove('is-pulse');void root.offsetWidth;root.classList.add('is-pulse');
    }
    function pick(c,focus){cells.forEach(function(x){var on=x===c;x.setAttribute('aria-checked',on);x.tabIndex=on?0:-1});cur=c;draw();if(focus)c.focus()}
    cells.forEach(function(c,i){
      c.addEventListener('click',function(){pick(c)});
      c.addEventListener('keydown',function(e){var n=null;if(e.key==='ArrowDown'||e.key==='ArrowRight')n=cells[(i+1)%cells.length];else if(e.key==='ArrowUp'||e.key==='ArrowLeft')n=cells[(i-1+cells.length)%cells.length];if(n){e.preventDefault();pick(n,true)}});
    });
    S.addEventListener('input',draw);P.addEventListener('input',draw);draw();
  }
  function all(){document.querySelectorAll('[data-ihx-cl]').forEach(init)}
  all();document.addEventListener('shopify:section:load',all);
  document.addEventListener('shopify:block:select',function(e){var c=e.target&&e.target.closest&&e.target.closest('.ihx-cl__cell');if(c)c.click()});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ihc-hub-band"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* Animations only run while a band is on screen (saves battery and CPU on long homepages). */
  function init() {
    var els = document.querySelectorAll('.ihc-hbd:not([data-io])');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (list) {
      list.forEach(function (x) { x.target.classList.toggle('is-in', x.isIntersecting); });
    }, { rootMargin: '100px 0px' });
    els.forEach(function (e) { e.setAttribute('data-io', ''); io.observe(e); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ihc-numakers"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(root.dataset.ready)return;root.dataset.ready='1';
    var tabs=[].slice.call(root.querySelectorAll('[role=tab]'));
    function pick(t,focus){
      tabs.forEach(function(x){var on=x===t;x.setAttribute('aria-selected',on);x.tabIndex=on?0:-1;var p=document.getElementById(x.getAttribute('aria-controls'));if(p)p.hidden=!on;});
      root.style.setProperty('--c',t.dataset.colour);
      root.classList.remove('is-swap');void root.offsetWidth;root.classList.add('is-swap');
      var bar=t.parentNode;if(bar.scrollWidth>bar.clientWidth){bar.scrollTo({left:t.offsetLeft-bar.clientWidth/2+t.offsetWidth/2,behavior:'smooth'});}
      if(focus)t.focus();
    }
    tabs.forEach(function(t,i){
      t.addEventListener('click',function(){pick(t)});
      t.addEventListener('keydown',function(e){
        var k=e.key,n=null;
        if(k==='ArrowDown'||k==='ArrowRight')n=tabs[(i+1)%tabs.length];
        else if(k==='ArrowUp'||k==='ArrowLeft')n=tabs[(i-1+tabs.length)%tabs.length];
        else if(k==='Home')n=tabs[0];else if(k==='End')n=tabs[tabs.length-1];
        if(n){e.preventDefault();pick(n,true);}
      });
    });
  }
  function all(){document.querySelectorAll('[data-ihx-nm]').forEach(init)}
  all();document.addEventListener('shopify:section:load',all);
  document.addEventListener('shopify:block:select',function(e){var t=e.target&&e.target.closest&&e.target.closest('.ihx-nm__tab');if(t)t.click();});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ihc-product-row"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* Add to cart without leaving the page: uses the theme's cart drawer when present, otherwise opens the cart. */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-ihx-add]');
    if (!form || !window.fetch) return;
    e.preventDefault();
    var drawer = document.querySelector('cart-drawer');
    var body = new FormData(form);
    if (drawer && drawer.getSectionsToRender) {
      body.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }).join(','));
      body.append('sections_url', window.location.pathname);
    }
    form.classList.add('is-busy');
    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: body })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        form.classList.remove('is-busy');
        if (res.status) { form.submit(); return; }
        if (drawer && drawer.renderContents) {
          drawer.classList.remove('is-empty');
          drawer.renderContents(res);
        } else { window.location.href = (window.routes && window.routes.cart_url) || '/cart'; return; }
        form.classList.add('is-done');
        var b = form.querySelector('span'); if (b) { b.textContent = 'Added'; setTimeout(function () { b.textContent = 'Add'; form.classList.remove('is-done'); }, 2000); }
      })
      .catch(function () { form.classList.remove('is-busy'); form.submit(); });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
